<script>
    export let funTable = {
        data: [],
    };
    export let data = [];
    export let noDataMesage = "";
    export let showAsGrid = false;
    export let rowlen = 0;
    const styleList = {
        err: "errStyle",
        warn: "warnStyle",
        prim: "primStyle",
        faded: "fadedStyle",
    };

    function funGen(action, id, rowObj) {
        return () => {
            action(id, rowObj);
        };
    }
</script>

{#if data.length === 0}
    <span class="emptyMsg">{noDataMesage}</span>
{:else if showAsGrid}
    <div class="gridTable" style={`--rowTemplate: repeat(${rowlen}, 1fr);`}>
        {#each data as row, rowId}
            {#each row.row as data, i}
                <div class="rowData">
                    <!-- {#if rowId === 0}
                        <span class="smallTitle">{data.title}</span>
                    {/if} -->
                    <span class:nullSmalltitle={rowId !== 0} class="smallTitle"
                        >{data.title}</span
                    >
                    {#if data.type === "icon"}
                        <span
                            class={`${
                                styleList[data.style]
                                    ? styleList[data.style]
                                    : ""
                            } material-icons`}
                        >
                            {data.val}
                        </span>
                    {:else}
                        <span
                            class={`${
                                styleList[data.style]
                                    ? styleList[data.style]
                                    : ""
                            } smallText`}>{data.val}</span
                        >
                    {/if}
                </div>
            {/each}

            <div class="funList">
                {#if funTable.data.length !== 0}
                    {#each funTable.data as fun, i}
                        <div
                            class:activeIconDisabled={fun.disabled}
                            class="activeIcon inactiveIconPlus"
                            on:click={funGen(fun.action, rowId, row)}
                        >
                            <span class="material-icons">
                                {fun.icon}
                            </span>
                        </div>
                    {/each}
                {/if}
            </div>
        {/each}
    </div>
{:else}
    <div class="table">
        {#if data.length === 0}
            <span class="emptyMsg">{noDataMesage}</span>
        {/if}
        {#each data as row, rowId}
            <div class="row">
                {#each row.row as data, i}
                    <div class="rowData">
                        <span
                            class:nullSmalltitle={rowId !== 0}
                            class="smallTitle">{data.title}</span
                        >
                        {#if data.type === "icon"}
                            <span
                                class={`${
                                    styleList[data.style]
                                        ? styleList[data.style]
                                        : ""
                                } material-icons`}
                            >
                                {data.val}
                            </span>
                        {:else}
                            <span
                                class={`${
                                    styleList[data.style]
                                        ? styleList[data.style]
                                        : ""
                                } smallText`}>{data.val}</span
                            >
                        {/if}
                    </div>
                {/each}
                {#if funTable.data.length !== 0}
                    <div class="funList">
                        {#each funTable.data as fun, i}
                            <div
                                class:activeIconDisabled={fun.disabled}
                                class="activeIcon inactiveIconPlus"
                                on:click={funGen(fun.action, rowId, row)}
                            >
                                <span class="material-icons">
                                    {fun.icon}
                                </span>
                            </div>
                        {/each}
                    </div>
                {/if}
            </div>
            <div class="rowBottom" />
        {/each}
    </div>
{/if}

<style>
    .errStyle {
        color: var(--err);
    }
    .warnStyle {
        color: var(--wanr);
    }
    .primStyle {
        font-weight: 600;
        color: var(--prim);
    }
    .fadedStyle {
        color: var(--back_D12);
    }

    .gridTable {
        display: grid;
        --rowTemplate: 1fr;
        grid-template-columns: var(--rowTemplate) auto;
    }

    .emptyMsg {
        font-weight: 100;
        color: var(--back_D18);
    }
    .row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 1.75rem;
        padding: 0 5px;
        padding-bottom: 1px;
        margin-bottom: 3px;
        /* border-bottom: solid 1px var(--back_D12); */
    }
    .rowData {
        display: flex;
        flex-direction: column;
    }
    .rowBottom {
        width: 100%;
        height: 2px;
        margin-bottom: 3px;
        background-image: linear-gradient(
            to right,
            var(--back),
            var(--back_D12) 20%,
            var(--back_D12) 80%,
            var(--back)
        );
        /* background-image: linear-gradient(to right, var(--back), var(--back_D12) 15%, var(--prim_L15) 50%, var(--back_D12) 85%, var(--back)); */
    }
    .funList {
        justify-self: flex-end;
        display: flex;
        align-items: center;
    }
    .funList > * {
        margin: 0 7px;
    }
    .activeIcon > .material-icons {
        font-size: 1.6rem;
    }

    .smallTitle {
        font-size: 0.9rem;
        font-weight: 300;
        margin-bottom: 3px;
        /* margin-left: 3px;
        margin-top: 13px; */

        /* position: absolute;
        top: 0;
        left: 0; */
        white-space: pre;
    }
    .smallText {
        font-size: 1.1rem;
        font-weight: 300;
        margin-left: 5px;
        white-space: pre;
    }
    .nullSmalltitle {
        max-height: 0;
        overflow: hidden;
    }
</style>
